import { useAccount, useReadContract } from 'wagmi'

import useTokenGGPContract from './contracts/tokenGGP'

import { useValueTokens } from '@/contexts/VaultTokensContext'
import { HexString } from '@/types/cryptoGenerics'

export const useGGPVaultAllowance = (address: HexString) => {
  const { currentToken } = useValueTokens()
  const { chain } = useAccount()
  const { abi, address: tokenAddr } = useTokenGGPContract()
  const vault = currentToken.tokenAddresses[1][chain?.id] as `0x${string}`
  const resp = useReadContract({
    address: tokenAddr as `0x${string}`,
    abi: abi,
    functionName: 'allowance',
    args: [address, vault],
    query: {
      refetchInterval: 1000,
    },
  })

  return resp
}
